const localKey = 'token'

export const getAuthHeader = () => {
  return {
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + localStorage.getItem(localKey),
  }
}

export const bikinParam = (param) => {
  let str = ''
  for (let key in param) {
    if (param[key] != '' && param[key] != undefined) {
      if (str != '') {
        str += '&'
      }
      str += key + '=' + encodeURIComponent(param[key])
    }
  }
  return str
}

export const unencodedParam = (param) => {
  let str = ''
  for (let key in param) {
    if (param[key] != '' && param[key] != undefined) {
      if (str != '') {
        str += '&'
      }
      str += key + '=' + param[key]
    }
  }
  return str
}

export const getColor = (status) => {
  switch (status) {
    case 'CRASH':
      return '#c42f26'
    case 'IDLE':
      return '#4e4e4e'
    case 'STOP':
      return '#000000'
    case 'SILENCE':
      return '#ce6f1b'
    case 'MOVING':
      return '#398d3a'
    default:
      return 'info'
  }
}
